export const getNotNullObjectFieldFilter =
  <TObject extends object>(accessor: (object: TObject) => any) =>
  (item: TObject) =>
    typeof item === 'object' && accessor(item) !== null;
